<template>
  <div v-if="visibleItems.length" class="admin-notify-stack" aria-live="polite">
    <div class="admin-notify-head">
      <span class="admin-notify-head-title">待办提醒</span>
      <span class="admin-notify-head-count">{{ visibleAll.length }}</span>
      <span v-if="overflowCount > 0" class="admin-notify-head-more">可滚动查看</span>
      <button type="button" class="admin-notify-head-btn admin-notify-head-btn--inbox" @click="openMessageCenter">
        消息中心
        <span v-if="unreadCount > 0" class="admin-notify-inbox-badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </button>
      <button type="button" class="admin-notify-head-btn" @click="dismissAll">全部关闭</button>
    </div>
    <div class="admin-notify-scroll">
      <article
        v-for="item in visibleItems"
        :key="item.id"
        class="admin-notify-card"
        :class="'admin-notify-card--' + typeClass(item.type)"
        @click="go(item)"
      >
        <button
          type="button"
          class="admin-notify-close"
          title="关闭"
          aria-label="关闭"
          @click.stop="dismiss(item.id)"
        >
          ×
        </button>
        <h4 class="admin-notify-title">{{ item.title }}</h4>
        <p v-if="item.summary" class="admin-notify-summary">{{ item.summary }}</p>
        <p v-if="item.at" class="admin-notify-at">{{ item.at }}</p>
      </article>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useAdminNotifications } from '@/composables/useAdminNotifications'

const router = useRouter()
const { visibleItems, visibleAll, overflowCount, unreadCount, dismiss, dismissAll } = useAdminNotifications()

function openMessageCenter() {
  router.push('/operation/messages/center').catch(() => {})
}

function typeClass(type) {
  const t = String(type || '').toLowerCase().replace(/_/g, '-')
  return t || 'default'
}

function go(item) {
  if (!item) return
  const path = String(item.linkPath || '').trim()
  if (!path) return
  const q = item.linkQuery && typeof item.linkQuery === 'object' ? item.linkQuery : {}
  router.push({ path, query: q }).catch(() => {})
  dismiss(item.id)
}
</script>

<style scoped>
.admin-notify-stack {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1200;
  width: min(360px, calc(100vw - 40px));
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}
.admin-notify-scroll {
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* 约两张卡片高度，多的纵向滚动 */
  max-height: 220px;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px;
  pointer-events: auto;
  scrollbar-width: thin;
}
.admin-notify-scroll::-webkit-scrollbar {
  width: 6px;
}
.admin-notify-scroll::-webkit-scrollbar-thumb {
  background: #d0d5dd;
  border-radius: 999px;
}
.admin-notify-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #101828;
  color: #fff;
  border-radius: 10px;
  font-size: 13px;
  pointer-events: auto;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.18);
}
.admin-notify-head-title {
  font-weight: 700;
}
.admin-notify-head-count {
  min-width: 22px;
  padding: 0 7px;
  border-radius: 999px;
  background: #f79009;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}
.admin-notify-head-more {
  font-size: 11px;
  color: #98a2b3;
}
.admin-notify-head-btn {
  margin-left: auto;
  border: none;
  background: transparent;
  color: #d0d5dd;
  font-size: 12px;
  cursor: pointer;
  padding: 2px 4px;
}
.admin-notify-head-btn:hover {
  color: #fff;
}
.admin-notify-head-btn--inbox {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.admin-notify-inbox-badge {
  min-width: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #f79009;
  color: #101828;
  font-size: 10px;
  font-weight: 800;
  line-height: 16px;
  text-align: center;
}
.admin-notify-card {
  position: relative;
  padding: 12px 36px 12px 14px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #eaecf0;
  border-left-width: 4px;
  box-shadow: 0 10px 28px rgba(16, 24, 40, 0.12);
  cursor: pointer;
  pointer-events: auto;
  transition: transform 0.12s ease, box-shadow 0.12s ease;
}
.admin-notify-card:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 32px rgba(16, 24, 40, 0.16);
}
.admin-notify-card--activity-cancel-request {
  border-left-color: #6941c6;
}
.admin-notify-card--activity-signup-review {
  border-left-color: #b54708;
}
.admin-notify-card--activity-fee-review {
  border-left-color: #1d4ed8;
}
.admin-notify-card--supply-review {
  border-left-color: #067647;
}
.admin-notify-card--supply-revision-review {
  border-left-color: #5925dc;
}
.admin-notify-card--new-registrant {
  border-left-color: #2f6af6;
}
.admin-notify-card--renewal-fee-review {
  border-left-color: #7c3aed;
}
.admin-notify-card--membership-apply-review {
  border-left-color: #dc6803;
}
.admin-notify-card--membership-fee-review {
  border-left-color: #0891b2;
}
.admin-notify-card--membership-apply-seal {
  border-left-color: #be123c;
}
.admin-notify-card--network-connection-review {
  border-left-color: #e8954a;
}
.admin-notify-card--service-form-submit {
  border-left-color: #2f6af6;
}
.admin-notify-card--service-form-update {
  border-left-color: #f04438;
}
.admin-notify-close {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 6px;
  background: #f2f4f7;
  color: #475467;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
}
.admin-notify-close:hover {
  background: #eaecf0;
  color: #101828;
}
.admin-notify-title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: #101828;
  line-height: 1.35;
}
.admin-notify-summary {
  margin: 0 0 4px;
  font-size: 13px;
  color: #475467;
  line-height: 1.45;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.admin-notify-at {
  margin: 0;
  font-size: 12px;
  color: #98a2b3;
}
</style>
